import React from 'react';
import MovieForm from '../Components/MovieForm';

const AddMovie = () => {
  return (
    <div>
      <MovieForm />
    </div>
  );
};

export default AddMovie;
